import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import Spinner from "./views/Spinner/Spinner";

import "./assets/style.css";

// ✅ Material-UI v4 imports (compatible with your package.json)
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// ✅ Bootstrap CSS + bundle JS (no Tether required)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

let host = window.location.host;
let parts = host.split(".");
let subdomain = "";

if (parts.length >= 3) {
  subdomain = parts[0];
  parts.splice(0, 1);
  if (subdomain === "admin") {
    window.location = "https://nhim.itl.ng/admin";
  }
}

// Create theme for Material-UI v4
const theme = createMuiTheme({
  // Add your theme customization here if needed
});

ReactDOM.render(
  <Suspense fallback={<Spinner />}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
        {/* Example floating back button */}
        {/* <Fab
          variant="extended"
          color="secondary"
          aria-label="edit"
          style={{
            position: "fixed",
            bottom: "0",
            right: "0",
            margin: "20px",
          }}
          onClick={() => window.history.back()}
        >
          <ArrowBackIcon /> &nbsp; Previous
        </Fab> */}
      </ThemeProvider>
    </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);
